import { useState } from "react";

// Custom hook to manage state for objects
const useObjectState = (initialState) => {
  // Use useState with an object as the initial state
  const [state, setState] = useState(initialState);

  // Function to update a single property of the object
  const updateProperty = (newState) => {
    setState({ ...state, ...newState });
  };

  // Return state object and update function
  return [state, updateProperty];
};

export default useObjectState;
